import React, { useState, forwardRef, useImperativeHandle } from 'react';
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import {FormControl, FormControlLabel, Radio, RadioGroup, Typography} from "@mui/material";
import {ProviderStepProps, TypeCredit} from "@/types/api/user/home.type.data";

const ProviderTabs = forwardRef(({data, onSubmit}: ProviderStepProps, ref) => {
    const [optionValue, setOptionValue] = useState<TypeCredit>("20card");

    const handleRadioChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const selectedValue = e.target.value as TypeCredit;
        setOptionValue(selectedValue);
    };

    const handleSubmit = () => {
        const submitData = {
            provider_key: optionValue,
        };
        onSubmit(submitData);
    };

    useImperativeHandle(ref, () => ({
        handleSubmit
    }));

    return (
        <FormControl component="fieldset" sx={{display: "flex", flexDirection: "column", alignItems: "start", width: "100%"}}>
            <TypoGraphyKit sx={{color: "white", mb: 2}}>
                لطفا نوع اعتبار خود را تعیین نمایید:
            </TypoGraphyKit>

            <RadioGroup onChange={handleRadioChange} sx={{gap: 2}}>
                {data.map((e) => (
                    <div key={e.provider_key}>
                        <FormControlLabel
                            sx={{display:'flex', alignItems:'center', gap:2}}
                            value={e.provider_key}
                            checked={e.provider_key === optionValue}
                            control={
                                <Radio sx={{color: "white"}} />
                            }
                            label={
                                <TypoGraphyKit sx={{color: "white"}}>
                                    {e.provider_title}
                                </TypoGraphyKit>
                            }
                        />
                        {optionValue === e.provider_key && (
                            <Typography sx={{ color: "gray", marginRight: 10 }}>
                                {e.provider_description}
                            </Typography>
                        )}
                    </div>
                ))}
            </RadioGroup>
        </FormControl>
    );
});

ProviderTabs.displayName = 'ProviderTabs';

export default ProviderTabs;